import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustLine } from './TrustLine';
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-ivory" data-id="element-107" data-mp="1o5zvmfc0uzay">
      <div className="max-w-2xl mx-auto px-5 sm:px-8 py-14 sm:py-20 text-center" data-id="element-108" data-mp="222mzl22e6pqd">
        <ShieldCheckIcon className="w-7 h-7 mx-auto text-sage" aria-hidden="true" data-id="element-109" data-mp="1x4v09mzf41c5" />
        <h2 id="guarantee-heading" className="mt-5 font-serif font-normal text-ink text-[28px] sm:text-[38px]" data-id="element-110" data-mp="19f0mn379y8qu">
          7-day guarantee — no questions asked
        </h2>

        <p className="mt-6 font-serif italic text-ink text-[21px] sm:text-[26px] leading-snug" data-id="element-111" data-mp="1j5vdylzdnyj5">
          Download it tonight. Open the volume for the month you&apos;re in. Do
          one Sunday with it.
        </p>

        <p className="mt-6 text-[17px] sm:text-[18px] leading-[1.6] text-ink-soft" data-id="element-112" data-mp="qlwu5l5sm1xt">
          That&apos;s all it takes to know. If within 7 days you don&apos;t see
          exactly what&apos;s due this month, in what order, with the numbers
          already done for you — we refund 100%: no forms, no hoops, no hard
          feelings.
        </p>

        <div className="mt-10 flex flex-col items-center" data-id="element-113" data-mp="yqmddo0nxtph">
          <CtaButton href="#pricing" size="sm" data-id="element-114" data-mp="12qohe3tvez7x">
            Yes, I want the complete plan
          </CtaButton>
          <TrustLine className="mt-4 justify-center" data-id="element-115" data-mp="616z8pdpbkpc" />
        </div>
      </div>
    </section>;
}